<template>
  <div>
    <el-row>
      <el-col :span="24"> {{ packingListName[this.printForm.language] }} </el-col>
    </el-row>
    <el-row>
      <el-col :span="14">
        <el-row v-for="(item, index) in sender" :key="item">
          <el-col :span="2" />
          <el-col :span="5"> {{ KeyNames(index, "senderKey") }}: </el-col>
          <el-col :span="15">
            {{ item }}
          </el-col>
          <el-col :span="2" />
        </el-row>
        <el-row class="receiver">
          <el-col>
            <el-row v-for="(item, index) in customerData" :key="item">
              <el-col :span="2" />
              <el-col :span="5"> {{ KeyNames(index, "receiverKey") }}: </el-col>
              <el-col :span="15">
                {{ item }}
              </el-col>
              <el-col :span="2" />
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10">
        <el-row>
          <el-col :span="24">
            <img
              style="left: 0px"
              width="300px"
              src="https://raw.githubusercontent.com/sensemore/sensemore-icon/master/sensemore-smart-machine-health-xs.png"
            />
          </el-col>
        </el-row>
        <el-row style="float: right">
          <el-col :span="24"> {{ date }} </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-col :span="24">
      <el-table border :data="printForm.items">
        <el-table-column type="index" label="Index" width="70" />
        <el-table-column
          prop="description"
          :label="tableLocazation('description')"
        />
        <el-table-column prop="quantity" :label="tableLocazation('quantity')" />
        <el-table-column prop="unit" :label="tableLocazation('unit')" />
        <el-table-column
          prop="netWeight"
          :label="tableLocazation('netWeight')"
        />
        <el-table-column
          prop="grossWeight"
          :label="tableLocazation('grossWeight')"
        />
      </el-table>
    </el-col>
    <el-row>
      <el-col :span="12">
        <el-row>
          <el-col class="border">
            {{ dimensionsBox[this.printForm.language] }}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="border">
            {{ printForm.length }}cm X {{ printForm.width }}cm X {{ printForm.height }}cm  
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col class="border"> {{ totalGrossWeight[this.printForm.language] }}(Gram) </el-col>
        </el-row>
        <el-row>
          <el-col class="border"> {{ printForm.TotalGrossWeight }} gram </el-col>
        </el-row>
      </el-col>
    </el-row>
    <br />
    <el-row>
      <el-col :span="12">
        <h3>{{ macAddressListName[this.printForm.language] }}</h3>
        <el-table :data="form.hardwares" border>
          <el-table-column type="index" width="70" label="Index" />
          <el-table-column prop="macAddress" label="macAddress" />
        </el-table>
      </el-col>
    </el-row>
    <br />
    <el-row>
      <el-col>
        {{ packageNumber[this.printForm.language] }} : {{ form._id }}
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "Shipping_Cargo",
  components: {},
  props: {
    printForm: {
      type: Object,
    },
    form: {
      type: Object,
    },
    customerData: {
      type: Array,
    },
  },
  data() {
    return {
      macAddressListName: {
        en: "MacAddress List",
        tr: "MacAddress Listesi",
      },
      packingListName:{
        en: "PACKING LIST",
        tr: "PAKET LİSTESİ",
      },
      index: "Item No",
      descriptionName: "Description of Goods",
      quantityName: "Quantity",
      unitName: "Unit",
      netWeightName: "Net Weight",
      grossWeightName: "Gross Weight",
      totalGrossWeight: {
        en: " Total Gross Weight ",
        tr: " Toplam Brüt Ağırlık ",
        value: "130",
      },
      packageNumber: {
        en: "Package Number",
        tr: "Kargo Numarası",
      },
      dimensionsBox: {
        en: "Dimensions of Box (Length X Width X Height) ",
        tr: "Koli Ölçüleri (Uzunluk X Genişlik X Yükseklik) ",
        value: " 14 cm X 8 cm X 4 cm",
      },
      tableTitle: {
        description: {
          en: "Description",
          tr: "Açıklama",
        },
        quantity: {
          en: "Quantity",
          tr: "Miktar",
        },
        unit: {
          en: "Unit",
          tr: "Birim",
        },
        netWeight: {
          en: "Net Weight",
          tr: "Net Ağırlık",
        },
        grossWeight: {
          en: "Gross Weight",
          tr: "Brüt ağırlık",
        },
      },
      sender: [
        "SENSEMORE TEKNOLOJİ A.Ş.",
        "Reşitpaşa Mah.Katar Cad.Teknokent ARI 4 Binası No: 2 / 50 / 6 Maslak Sarıyer İstanbul",
        "1871064485",
        "+90 507 267 28 02",
        "canaksu@sensemore.io",
        "www.sensemore.io",
      ],
      senderKey: [
        { en: "Sender", tr: "Gönderici" },
        { en: "Address", tr: "Adres" },
        { en: "Tax Number", tr: "Vergi Numarası" },
        { en: "Telephone", tr: "Telefon" },
        { en: "E-mail", tr: "E-Posta" },
        { en: "Web", tr: "Web" },
      ],
      receiverKey: [
        { en: "Shipped to", tr: "Alıcı" },
        { en: "Address", tr: "Adres" },
        { en: "Telephone", tr: "Telefon" },
        { en: "Fax", tr: "Fax" },
        { en: "Attention to", tr: "İlgili Kişi" },
        { en: "Po Number", tr: "Posta Kodu" },
      ],
    };
  },
  computed: {
    date() {
      return dayjs().format("DD-MM-YYYY");
    },
  },
  methods: {
    tableLocazation(title) {
      return this.tableTitle[title][this.printForm.language];
    },
    KeyNames(index, type) {
      return this[type][index][this.printForm.language];
    },
    emit() {
      this.$emit("created");
      this.$emit("canceled");
    },
  },
  watch: {},
};
</script>
<style scoped>
.div {
  margin: 10px;
}
.border {
  border: 1px solid #ebeef5;
}
.receiver {
  margin-top: 15px;
}
.layout {
  display: flex;
  flex-direction: row;
}
.landing {
  padding-right: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.el-menu-vertical {
  min-height: calc(100vh - 60px);
}
.header {
  display: flex;
  color: white;
  align-items: center;
  flex-direction: row;
  background: #343a40;
  padding-left: 30px;
  padding-right: 15px;
  height: 40px;
}
</style>